import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Videos from '../component/Videos'



import { fetchFromAPI } from '../utils/fetchFromApi'



const SearchFeed = () => {
  const {searchTerm}=useParams();
    
    const[videos, setVideos]=useState([]);
    useEffect(()=>{
           fetchFromAPI(`search?part=snippet&q=${searchTerm}`)
            .then((data)=>setVideos(data.items)).catch((err)=>{
              console.log(err);

            })

    },[searchTerm])
    // console.log(videos);
  return (
    <div>
         
        <h3 className='fw-bold ms-2'> Search Result For : <span className='text-danger mx-2'>{searchTerm} </span> Videos</h3>
        <Videos videos={videos} />
    </div>
  )
}

export default SearchFeed
